import { createSlice } from "@reduxjs/toolkit";
import { isNull, isUndefined } from "lodash";

export const memberInitialState = {
  member: null,
  userSubId: null,
  userEmail: null,
};
export const sliceName = "member";
export const memberSlice = createSlice({
  name: sliceName,
  initialState: memberInitialState,
  reducers: {
    setMember: (state, action) => {
      const { payload } = action;
      if (isNull(payload) || isUndefined(payload?.id)) return;
      state.member = action.payload;
    },
    setUserSubId: (state, action) => {
      state.userSubId = action.payload;
    },
    setUserEmail: (state, action) => {
      state.userEmail = action.payload;
    },
  },
});

export const { setMember, setUserSubId, setUserEmail } = memberSlice.actions;
export const selectMember = (state) => state[sliceName].member;
export const selectUserEmail = (state) => state[sliceName].userEmail;
export const selectUserSubId = (state) => state[sliceName].userSubId;
